import React from "react";
import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";
import Home from "../components/home/Home";
import SiteHome from "../components/siteHome/SiteHome";
import Tiers from "../components/tiers/Tiers";
import Login from "../oidcauthentication/Login";
import Settings from "../components/settings/Settings";
import DashboardCustomize from "../components/dashboard/Customize";
import Dashboard from "../components/dashboard/DigitalTier";
import QuickLinks from "../components/quickLinks/QuickLinks";
import Recognition from "../components/kaizen/Recognition";
import Error from "../components/common/errors/Errors";
import Apps from "../components/siteApps/SiteApps";
import Schedulers from "../components/common/mailer/Scheduler";
import AdminConsole from "../components/adminConsole/AdminConsole";
import RaiseCI from "../components/kaizen/raiseCI/RaiseCI";
import EditCI from "../components/kaizen/editCI/EditCI";
import SiteFocalInformation from "../components/kaizen/siteFocalInformation/SiteFocalInformation";
import CIList from "../components/kaizen/ciList/CIList";
import Nomination from "../components/kaizen/nomination/Nomination";
import Category from "../components/kaizen/Category";
import NominatedKaizen from "../components/kaizen/admin/nominatedKaizen/NominatedKaizen";
import AdminKaizen from "../components/kaizen/admin/AdminKaizen";
import DeleteKaizen from "../components/kaizen/admin/deleteKaizen/DeleteKaizen";
import ViewWB from "../components/sps/ViewWB";
import * as utils from "../common/utils";

export const DefaultRoute = () => {
  const tenantId = utils.get("tenantId");
  const path = `/projects/${tenantId}`;
  return (
    <BrowserRouter basename={path}>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route
          path="email"
          element={<Schedulers isEmail={true} showTemplateEditor={true} />}
        />
        <Route path="settings/:category/:site/:app" element={<Settings />} />
        <Route exact path="/SiteHome/:category/:site" element={<SiteHome />} />
        <Route exact path="/tiers/:category/:site/:app" element={<Tiers />} />
        <Route exact path="/siteApp/:category/:site/:app" element={<Apps />} />
        <Route exact path="/home/:category" element={<Home />} />
        <Route path="adminconsole" element={<AdminConsole />} />
        <Route path="dashboard/:sbg/:site/:tier" element={<Dashboard />} />
        <Route path="/recognition/:category/:site/" element={<Recognition />} />
        <Route
          path="customize/dashboard/:site/:tier/:sbg"
          element={<DashboardCustomize />}
        />
        <Route path="/preview/:sbg/:site/:tier" element={<Dashboard />} />
        <Route path="/tiers/layout" element={<DashboardCustomize />} />
        <Route path="/category/:category/:site/" element={<Category />} />
        <Route
          exact
          path="/quickLink/:category/:site"
          element={<QuickLinks />}
        />
        <Route
          exact
          path="/siteApp/:category/:site/kaizen/raiseci"
          element={<RaiseCI />}
        />
        <Route
          exact
          path="/siteApp/:category/:site/kaizen/nomination"
          element={<Nomination />}
        />
        <Route
          exact
          path="/siteApp/:category/:site/kaizenAdmin/nominatedKaizen"
          element={<NominatedKaizen />}
        />
        <Route
          exact
          path="/siteApp/:category/:site/kaizen/admin/:app"
          element={<AdminKaizen />}
        />
        <Route
          exact
          path="/siteApp/:category/:site/kaizen/:query"
          element={<CIList />}
        />
        <Route
          exact
          path="/siteApp/:category/:site/kaizen/cilist/:query"
          element={<CIList />}
        />
        <Route
          exact
          path="/siteApp/:category/:site/kaizen/sitefocalinfo"
          element={<SiteFocalInformation />}
        />
        <Route
          exact
          path="/siteApp/:category/:site/kaizen/editci/:query/:kaizenId"
          element={<EditCI />}
        />
        <Route
          exact
          path="/siteApp/:category/:site/kaizen/delete-kaizen"
          element={<DeleteKaizen />}
        />
        <Route exact path="/sps/whiteboard/:id/:tab" element={<ViewWB />} />
        <Route exact path="/error/:site/" element={<Error />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export const AuthRoute = () => (
  <Routes>
    {
      //<Route path='/OAuth/Index' element={<Login />} />
    }
    <Route path="/" element={<Login />} />
  </Routes>
);
